
import CityPage from '@/components/dynamicPageSections/cityPage';
export default {
    components: {
        CityPage
    }
}
